import LinkRouter from "../navigation/LinkRouter";
import {
  ExpendableEntryContainer,
  ExpendableEntryItem,
} from "./ExpandableEntry";
import { LayoutGrid, Mailbox } from "lucide-react";
import { ReactNode, useContext } from "react";
import { CurrentUserContext } from "../context/RequireAuth";
import { isUserAdmin } from "../../common/userUtils";
import { Badge, Box } from "@mui/material";
import { StatusContext } from "components/context/StatusContextProvider";

type Props = {
  selected: boolean;
  open: boolean;
  onClick: () => void;
};

export default ({ selected, open, onClick }: Props) => {
  const currentUser = useContext(CurrentUserContext);
  const {
    adminLeadsActionNeededCount,
    // adminApplicationActionNeededCount,
  } = useContext(StatusContext);
  let entries: ReactNode[] = [];
  if (isUserAdmin(currentUser)) {
    entries = [
      <Box
        key={`/tools/advisor-administration`}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          paddingRight: "20px",
        }}
      >
        <LinkRouter
          onClick={onClick}
          to={`/tools/advisor-administration`}
          sx={{ width: "100%" }}
        >
          <ExpendableEntryItem
            dense={true}
            content="Advisors"
            selected={new RegExp(`/tools/advisor-administration?.*$`).test(
              location.pathname,
            )}
          />
        </LinkRouter>
        <LinkRouter to="/tools/advisor-applications" onClick={onClick}>
          {/* Waiting to enable this until we get the queue down to a manageable size. */}
          {/* <Badge badgeContent={adminLeadsActionNeededCount} color="primary"> */}
          <Mailbox
            size={18}
            color={
              location.pathname === "/tools/advisor-applications"
                ? "#198282"
                : "#8E9598"
            }
          />
          {/* </Badge> */}
        </LinkRouter>
      </Box>,
      <Box
        key={`/tools/family-directory`}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          paddingRight: "20px",
        }}
      >
        <LinkRouter
          onClick={onClick}
          to={`/tools/family-directory`}
          key={`/tools/family-directory`}
          sx={{ width: "100%" }}
        >
          <ExpendableEntryItem
            dense={true}
            content="Families"
            selected={new RegExp(`/tools/family-directory?.*$`).test(
              location.pathname,
            )}
          />
        </LinkRouter>
        <LinkRouter to="/tools/pipeline-management" onClick={onClick}>
          <Badge
            badgeContent={adminLeadsActionNeededCount}
            color="primary"
            sx={{
              "& .MuiBadge-badge": {
                backgroundColor: "#ef7b77",
                fontSize: 9,
                height: 15,
                minWidth: 15,
              },
            }}
          >
            <Mailbox
              size={18}
              color={
                location.pathname === "/tools/pipeline-management"
                  ? "#198282"
                  : "#8E9598"
              }
            />
          </Badge>
        </LinkRouter>
      </Box>,
    ];
  }

  return (
    <ExpendableEntryContainer
      icon={<LayoutGrid height="20px" width="20px" stroke="#6B6E7B" />}
      selected={selected}
      open={open}
      onClick={onClick}
      content="Tools"
      url="/tools"
      stateName="faye.settings.tools-expanded"
    >
      {entries}
    </ExpendableEntryContainer>
  );
};
